<template>
  <banner
    v-if="showBanner"
    class="catalog-banner-component"
    :type="'dashboard'"
    :variant="bannerVariant"
    @banner-clicked="bannerClicked"
  >
    <template v-slot:banner-text>
      {{ bannerText }}
    </template>
    <template v-slot:banner-action>
      {{ bannerButtonText }}
    </template>
  </banner>
</template>

<script>
import { differenceInDays, differenceInSeconds } from 'date-fns';

import Banner from '@/components/ui/banner.vue';

import { parseMustacheTemplate } from '@/utils';

export default {
  name: 'CatalogBanner',
  components: { Banner },
  props: {
    dashboard: Object,
  },
  data() {
    return {
      timeLeftInSeconds: null,
      timerExpired: false,
      updateInterval: null,
    };
  },
  computed: {
    addonExpired() {
      if (this.catalogPage) {
        return this.catalogPage.isAddonExpired(this.$store);
      }
    },
    addonExpiring() {
      if (this.daysRemaining && this.bannerConfig?.showDays) {
        return this.daysRemaining < this.bannerConfig.showDays;
      }
    },
    bannerButtonText() {
      return this.bannerConfig?.actionText;
    },
    bannerConfig() {
      if (this.addonExpired) {
        return this.catalogPagePurchaseOrder.expiredBannerConfig;
      } else {
        return this.catalogPagePurchaseOrder.extendBannerConfig;
      }
    },
    bannerText() {
      return this.parseTemplate(this.bannerConfig?.textTemplate);
    },
    bannerVariant() {
      if (this.addonExpired) {
        return 'danger';
      }
    },
    catalogPage() {
      if (this.purchaseOrderUnlockingDashboard) {
        return this.$store.getters['catalog/pageList'].find(page => {
          return page.purchaseOrderId === this.purchaseOrderUnlockingDashboard.id;
        });
      }
    },
    catalogPagePurchaseOrder() {
      if (this.catalogPage) {
        return this.catalogPage.catalogPageRootPurchaseOrder(this.$store);
      }
    },
    catalogPagePRs() {
      if (this.catalogPage) {
        return this.catalogPage.catalogPagePurchaseReceipts(this.$store);
      }
    },
    daysRemaining() {
      if (this.catalogPage && !this.addonExpired) {
        const receipts = this.catalogPage.activeCatalogPagePurchaseReceipts(this.$store).filter(receipt => receipt.expiresAt);
        if (receipts?.length > 0) {
          return differenceInDays(receipts[0].expiresAt, new Date());
        }
      }
    },
    purchaseOrderUnlockingDashboard() {
      return (this.$store.getters['purchaseOrders/rootAddon'] || [])
        .find(po => (this.dashboard?.unlockedBy || []).includes(po.id));
    },
    showBanner() {
      if (this.addonExpiring) {
        return true;
      } else if (this.addonExpired && this.bannerConfig.showDays) {
        const receipts = this.catalogPage.catalogPagePurchaseReceipts(this.$store).filter(r => r.expiresAt);
        const paidReceipts = receipts.filter(pr => {
          const po = this.$store.getters['purchaseOrders/get'][pr.purchaseOrderId];
          return po && !po.isFree;
        });
        if (paidReceipts?.length > 0) {
          return differenceInDays(new Date(), paidReceipts[0].expiresAt) < this.bannerConfig.showDays;
        }
      } else {
        return false;
      }
    },
    showCountdown() {
      if (this.hasExpiringAddon) {
        const secondsIn24Hours = 60 * 60 * 24;
        return this.timeLeftInSeconds < secondsIn24Hours;
      }
    },
    timeLeftLabel() {
      if (
        this.showCountdown &&
        this.timeLeftInSeconds &&
        !isNaN(this.timeLeftInSeconds)
      ) {
        const hours = Math.floor(this.timeLeftInSeconds / 60 / 60);
        const minutes = Math.floor(
          (this.timeLeftInSeconds - hours * 60 * 60) / 60,
        );
        const seconds = Math.floor(
          this.timeLeftInSeconds - hours * 60 * 60 - minutes * 60,
        );
        return `${hours} hours, ${minutes} minutes, ${seconds} seconds`;
      }
      // We want to round up when this mesage is display. differenceInDays will round down so we'll compensate by adding 1 to it
      return `${this.daysRemaining} days`;
    },
  },
  mounted() {
    this.runTimeUpdate();
    if (this.showCountdown) {
      this.updateInterval = setInterval(this.runTimeUpdate, 1000);
    }
  },
  methods: {
    bannerClicked() {
      const params = {
        show: true,
        catalogPageId: this.catalogPage?.id,
        source: {
          type: 'Catalog Banner',
        },
      };

      if (this.addonExpired) {
        params.activeSection = 'Extensions';
      }
      this.$store.dispatch('ui/toggleCatalogModal', params);
    },
    parseTemplate(template) {
      const translation = {
        product_name: this.catalogPage?.title || 'this add on',
        remain_time: this.timeLeftLabel,
      };

      return parseMustacheTemplate(template, translation);
    },
    runTimeUpdate() {
      this.timeLeftInSeconds = differenceInSeconds(
        this.addonExpirationDate,
        new Date(),
      );
      this.timerExpired = this.timeLeftInSeconds <= 0;
      if (this.timerExpired) {
        clearInterval(this.updateInterval);
      }
    },
  },
};
</script>
